import type { ReactElement } from 'react';
import type { ProjectContext } from '@atlassian/jira-providers-project-context/src/types';
import { useResource } from '@atlassian/jira-router';
import { projectContextResourceWithCache } from '@atlassian/jira-router-resources-project-context';

export type Props = {
	children: (arg1: ProjectContext) => ReactElement;
};

export const ProjectContextSubscriber = ({ children }: Props) => {
	const { data } = useResource(projectContextResourceWithCache);
	if (!data) return null;
	return children(data);
};
